/** True for a request axios dropped on purpose (AbortController), not a failure. */
export const isCanceledRequest = (error) =>
  error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError';

/**
 * The text to show for a failed task call, or null when the request was
 * canceled. `text` is the text of useText('tasks').
 */
export const crmTaskErrorText = (error, text) => {
  if (isCanceledRequest(error)) return null;
  const code = error?.response?.data?.errorCode;
  const codeText = code ? text(`errors.${code}`) : '';
  if (codeText) return codeText;
  // The mock rejects with a plain Error whose message is already French; an
  // axios network error has no response either but its message is technical.
  if (!error?.response && error?.message && !error?.isAxiosError) {
    return error.message;
  }
  return text('errors.default');
};
